<template lang="pug">
#wrap_sub
  .sub_left
  .sub_right
    .content_title
    .content_desc
      #s31
        .s31a.sub
          .in
            h2.s_tit
              span Nano Brewery
            p.ss_tit
              | 인더케그의 Smart Brewery Platform은 전문 양조인력 없이도 작은 공간에서 다양한 종류의 
              br
              | 수제맥주를 제조할수 있는 Nano Brewery(초소형 브루어리) 구축모델로도 활용될 수 있습니다.
          .s31_a
            .cont
              .top
                .in
                  .lt(data-aos='fade-right')
                    h3 안산 나노브루어리
                    .img
                      img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s31_lt.jpg' alt='')
                  .rg(data-aos='fade-right' data-aos-delay='200')
                    h3 울산 낭만브로이
                    .img
                      img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s31_rg.jpg' alt='')
              .bot
                .in
                  .lt(data-aos='fade-right')
                    h3
                      | 인더케그의 
                      br
                      | 나노브루어리 특징
                  .rg
                    ul
                      li(data-aos='fade-right' data-aos-delay='200')
                        h4 최소규모 수제맥주 제조가 가능한 
                          span.bold Nano Brewery
                          span.fz → 10평미만의 작은 공간에서 양조장 구축 가능
                      li(data-aos='fade-right' data-aos-delay='400')
                        h4 지역 특산물을 활용한 
                          span.bold 전용맥주 양조 가능
                      li(data-aos='fade-right' data-aos-delay='600')
                        h4
                          span.bold 맥주 제조 체험공방
                          | 으로 운영 가능
          .s31_b.sub
            .in
              .tit
                h3(data-aos='fade-up') NANO BREWERY
                p(data-aos='fade-up' data-aos-delay='200')
                  | 인더케그 기기만 있으면 그 자체로 발효/숙성이 가능하므로 
                  span.bold 200리터 미만의 초소형 브루어리 구축이 손쉽게 가능
                  | 합니다.  이러한 초소형 브루어리는 현재 안산과 울산에 구축이 완료되었고 
                  span.bold 200리터 맥즙 제조 설비와 기기 4대 설치로 7평 정도의 공간에서 수제맥주 생산이 가능
                  | 합니다.
              .cont
                .img(data-aos='fade-up')
                  img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s31b01.jpg' alt='')
                .img(data-aos='fade-up' data-aos-delay='200')
                  img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s31b02.jpg' alt='')
                .img(data-aos='fade-up' data-aos-delay='300')
                  img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s31b03.jpg' alt='')
                .img(data-aos='fade-up' data-aos-delay='400')
                  img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s31b04.jpg' alt='')
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>
<style></style>
